module.exports = __webpack_public_path__ + "media/img/why-vendor/venue-5847c6b1483313f9f4ca7084daff5106.svg";